<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container node_centent">
                <div class="title">
                    카테고리관리
                    <div class="refund_caption pt5">
                        하위 카테고리들은 APP에서 이름 오름차순으로 우선노출 합니다.
                    </div>
                </div>
                <div class="">
                    <content-category-component :categoryType="'categoryBasic'"></content-category-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

        </div>
    </div>
</template>

<script>
    import ContentCategoryComponent from "@/components/content/ContentCategoryComponent";
    export default {
        name: 'Categories',
        mixins: [],
        components: {ContentCategoryComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {z
        },
        destroyed() {
        },
        computed: {
        },
        methods: {

        },
        watch: {},
    }
</script>
